import React, { memo } from 'react'

//Libraries
import { Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { m } from 'framer-motion'
import { PropTypes } from "prop-types";

// Components
import Buttons from '../Button/Buttons'

// Data

const InteractiveBanners03 = (props) => {
    const style = { "--overlay-color": typeof (props.overlay) === "object" ? `linear-gradient(to right top, ${props.overlay.map((item, i) => item)})` : props.overlay }
    return (
        <Row className={`${props.grid ? props.grid : ""}${props.className ? ` ${props.className}` : ""}`} lg={3} sm={2}>
            {
                props?.data?.map((item, i) => {
                    return (
                        <m.div key={i} className="col" {...{ ...props.animation, transition: { delay: i * props.animationDelay } }}>
                            <div className="interactivebanners-style-03 g-0 relative overflow-hidden rounder-[6px]" style={style}>
                                {item?.image && (
                                    <a
                                        href={`https://kera.enfonoerp.com${item?.attachment}`}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div className="interactivebanners-box-image h-[250px] object-cover bg-no-repeat relative overflow-hidden">
                                            {item?.image && (
                                                <img
                                                    width={263}
                                                    height={202}
                                                    className="interactivebanners-img w-full relative overflow-hidden"
                                                    src={`https://kera.enfonoerp.com${item?.image}`}
                                                    alt="interactivebanners"
                                                />
                                            )}
                                            {!props?.link &&
                                                <div className="interactivebanners-btn border-2 border-transparent flex justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[44px] w-[44px] leading-10 p-0 z-[1] rounded-full text-center text-black">
                                                    <i className="fas fa-arrow-down flex items-center"></i>
                                                </div>
                                            }

                                            <div className="interactivebanners-box-hover absolute h-full w-full top-0 left-0"></div>
                                        </div>
                                    </a>
                                )}
                                <div className="interactivebanners-box-content bg-white text-center p-[10px] relative lg:p-[10px] xs:p-[10px]">
                                    {item?.title && <Link aria-label="link" className="interactivebanners-title font-medium text-darkgray font-serif text-md uppercase no-underline" to={item.titleLink}>{item.title}</Link>}
                                    <br />
                                    {item?.description && <span className="left-0 right-0 h-full w-full ">{item.description}</span>}
                                    <div className="content-hover-effect">
                                        <Buttons ariaLabel="interactive button" className="interactivebanners-box-sub-title relative p-0 font-medium font-serif uppercase after:h-[1px] after:bg-[#2ed47c] btn-link" to={props?.link ? item?.url : `https://kera.enfonoerp.com${item?.attachment}`} color="#2ed47c" size="lg" title={props?.link ? 'Apply Now' : 'Download Now'} />
                                    </div>
                                </div>
                            </div>
                        </m.div>
                    )
                })
            }
        </Row>
    )
}

InteractiveBanners03.defaultProps = {
    // data: InteractiveBannersData03,
    animationDelay: 0.2
}

InteractiveBanners03.propTypes = {
    className: PropTypes.string,
    grid: PropTypes.string,
    overlay: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array
    ]),
    animation: PropTypes.object,
    animationDelay: PropTypes.number,
    data: PropTypes.arrayOf(
        PropTypes.exact({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            img: PropTypes.string,
            imgLink: PropTypes.string,
            btnTitle: PropTypes.string,
            btnLink: PropTypes.string,
            titleLink: PropTypes.string,
            icon: PropTypes.string,
        })
    )
}

export default memo(InteractiveBanners03)
